'use strict';

module.exports = function() {
	if (!CK.user.$exists()) {
		const activePromo = require('../data/activePromo');

		// if (activePromo && activePromo.getProps()) {
		// 	return false;
		// }

		const CookieManager = require('ck-core-client/source/managers/CookieManager');
		var hideEmailCaptureCookie = CookieManager.mod().get('hideEmailCaptureModal');

		let timestamp;

		if (hideEmailCaptureCookie) {
			hideEmailCaptureCookie = JSON.parse(hideEmailCaptureCookie);
			if (hideEmailCaptureCookie.timestamp) {
				timestamp = moment(hideEmailCaptureCookie.timestamp);
			}
			return false;
		}

		if (
			!hideEmailCaptureCookie ||
			!hideEmailCaptureCookie.hide ||
			(timestamp && timestamp.isBefore(moment().subtract(10, 'days')))
		) {
			CookieManager.mod().set('hideEmailCaptureModal', {
				hide: true,
				timestamp: Date.now()
			});

			CK.trackAnalytic('EmailCaptureModalShown');

			return true;
		}
	}
};
